<template>
    <div>
        <div class="w-screen h-dvh max-w-full max-h-full landing flex flex-col justify-center items-center">
            <CoachingModeMarble class="size-15" is-loading />
            <div class="flex flex-col justify-start items-center gap-10 w-full md:w-150 text-center pt-4 px-10">
                <div class="flex flex-col gap-5 justify-center items-center pt-4">
                    <div class="text-ink flex md:flex-row flex-col">
                        <span class="display-serif">{{ t("feedback.switchingAccounts.title") }}</span>
                    </div>

                    <div class="body-small text-ink text-center w-full">{{ t("feedback.switchingAccounts.description") }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import CoachingModeMarble from "~vue/components/navigation/CoachingModeMarble.vue";
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const emit = defineEmits(["switchingComplete"]);
onMounted(() => {
    setTimeout(() => {
        // Emit the event after a delay to simulate the switching process
        emit("switchingComplete");
    }, 3500); // Adjust the delay as needed
});
</script>

<style scoped>
.landing {
    background-color: rgba(234, 184, 150, 0.6);
    background-image: linear-gradient(150deg, transparent 50%, rgba(234, 184, 150, 1) 90%), linear-gradient(230deg, transparent 65%, rgba(200, 158, 247, 1));
}
</style>
